import { AccountObjectFacade } from "../account-object/account-object.facade";
import { NotificationTemplateStoreFacade } from "./notification-template.store-facade";
import { NotificationTemplateApiFacade } from "./notification-template.api-facade";
import { NotificationTemplate } from "./notification-template.model";

export class NotificationTemplateFacade extends AccountObjectFacade<NotificationTemplate, NotificationTemplateApiFacade, NotificationTemplateStoreFacade> {
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.facade.ts